module.exports = __webpack_public_path__ + "static/media/1-3.79b89903.png";